import { render, staticRenderFns } from "./SelectionOrders.vue?vue&type=template&id=922226d2&scoped=true"
import script from "./SelectionOrders.vue?vue&type=script&lang=js"
export * from "./SelectionOrders.vue?vue&type=script&lang=js"
import style0 from "./SelectionOrders.vue?vue&type=style&index=0&id=922226d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922226d2",
  null
  
)

export default component.exports